import React from 'react';
const bonuses = [{
  num: '1',
  title: 'Habilidades de Comunicación',
  desc: 'Actividades específicas para trabajar la comunicación funcional en chicos con o sin diagnóstico.',
  value: '4.500',
  color: 'bg-blue-600'
}, {
  num: '2',
  title: 'Kit de Rutinas Visuales',
  desc: 'Tableros y secuencias para hogar, aula y consultorio. Para que el día sea más predecible (y más calmo).',
  value: '3.500',
  color: 'bg-teal-600'
}, {
  num: '3',
  title: 'Aprender Jugando',
  desc: 'Propuestas lúdicas listas para aplicar. Para que aprender no se sienta como obligación.',
  value: '3.500',
  color: 'bg-amber-600'
}, {
  num: '4',
  title: 'Aventuras para Colorear',
  desc: 'Láminas temáticas para trabajar concentración, motricidad fina y regulación emocional.',
  value: '3.000',
  color: 'bg-purple-600'
}];
export function BonusSection() {
  return <section className="py-12 md:py-24 px-4 bg-brand-light" data-id="element-18">
      <div className="max-w-5xl mx-auto" data-id="element-19">
        <div className="text-center mb-10 md:mb-16" data-id="element-20">
          <h2 className="text-3xl md:text-5xl font-black text-brand-dark mb-4" data-id="element-21">
            Comprando hoy también te llevás estos 4 regalos
          </h2>
          <p className="text-xl font-bold text-gray-600" data-id="element-22">
            (Incluidos sin costo adicional)
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-10 md:mb-12" data-id="element-23">
          {bonuses.map((b, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden border border-gray-200 shadow-lg flex flex-col h-full" data-id="element-24">
              <div className={`${b.color} p-6 flex items-center gap-4 text-white`} data-id="element-25">
                <div className="bg-white/20 text-white font-black text-xl w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-26">
                  {b.num}
                </div>
                <h3 className="text-xl md:text-2xl font-black leading-tight" data-id="element-27">
                  BONO {b.num} — {b.title}
                </h3>
              </div>

              <div className="p-6 md:p-8 flex flex-col flex-grow" data-id="element-28">
                <p className="text-gray-700 text-lg mb-8 flex-grow" data-id="element-29">{b.desc}</p>

                <div className="mt-auto pt-6 border-t border-gray-100 flex justify-between items-center" data-id="element-30">
                  <div className="text-gray-500 font-medium" data-id="element-31">
                    Valor: <span className="line-through" data-id="element-32">${b.value} ARS</span>
                  </div>
                  <div className="text-brand-green font-black text-xl" data-id="element-33">
                    Hoy: GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center mb-8" data-id="element-34">
          <p className="text-brand-orange font-bold text-lg" data-id="element-35">
            ⚡ Estos bonos solo están disponibles durante el período de
            relanzamiento.
          </p>
        </div>

        <div className="bg-white border-2 border-brand-green rounded-2xl p-6 md:p-8 text-center max-w-2xl mx-auto shadow-xl" data-id="element-36">
          <p className="text-xl text-gray-600 mb-2" data-id="element-37">
            Valor total de los 4 Bonos:{' '}
            <span className="line-through" data-id="element-38">$14.500 ARS</span>
          </p>
          <p className="text-3xl md:text-4xl font-black text-brand-green" data-id="element-39">
            🎁 GRATIS
          </p>
        </div>
      </div>
    </section>;
}